import { useTheme } from '@emotion/react';
import { Box, Button, Card, Grid, Modal, useMediaQuery } from '@mui/material';
import success from 'assets/lottie/success2.json';
import FlexBox from 'components/flexbox/FlexBox';
import { H1, H5 } from 'components/Typography';
import Lottie from 'lottie-react';

export default function SuccessModal2({
  showModal,
  setShowModal,
  title = '완료 팝업입니다',
  subtitle = '요청하신 내용이 완료되었습니다.',
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '95%' : isTablet ? '400px' : '400px',
    maxHeight: '90vh',
    overflowY: 'auto',
    backgroundColor: theme.palette.primary.white,
    border: 'none',
    boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.4)',
    outline: 'none',
    scrollbarWidth: 'thin',
    borderRadius: 6,
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
    },
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      disableEnforceFocus={true}
      disableBackdropClick={false}
      disableEscapeKeyDown={true}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        backdropFilter: 'blur(5px)',
        backgroundColor: 'transparent',
        outline: 'none',
      }}
    >
      <Card sx={modalStyle}>
        <FlexBox py={3} sx={{ flexDirection: 'column' }}>
          <Grid
            py={6}
            px={3}
            textAlign="center"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Lottie
              animationData={success}
              loop={false}
              autoplay={true}
              style={{
                width: '74px',
                height: '74px',
                marginBottom: '18px',
              }}
            />

            <H1
              fontSize={27}
              textAlign="center"
              mb={1}
              color={theme.palette.primary.dark}
            >
              {title}
            </H1>
            <H5
              textAlign="center"
              style={{ fontWeight: 500, color: theme.palette.primary.grey }}
            >
              {subtitle}
            </H5>
          </Grid>

          <Box
            display="flex"
            justifyContent="center"
            mt={3}
            width="100%"
            px={3}
          >
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{
                color: theme.palette.primary.white,
                backgroundColor: '#3182F7',
                borderRadius: '12px',
                width: '100%',
                height: '50px',
                '&:hover': {
                  backgroundColor: '#2161c5',
                },
              }}
            >
              확인
            </Button>
          </Box>
        </FlexBox>
      </Card>
    </Modal>
  );
}
